import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {NgbActiveModal, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  merge,
  Observable, of,
  OperatorFunction,
  Subject,
  switchMap
} from 'rxjs';
import { LocationsService } from 'src/app/services/locations.service';
import { PlayersService } from 'src/app/services/players.service';
import {type} from "os";

@Component({
  selector: 'app-create-player-modal',
  templateUrl: './create-player-modal.component.html',
  styleUrls: ['./create-player-modal.component.scss'],
})
export class CreatePlayerModalComponent implements OnInit {
  public TITLE_CHOICES = [
    ['3un', '3юн'],
    ['2un', '2юн'],
    ['1un', '1юн'],
    ['1', 'I'],
    ['2', 'II'],
    ['3', 'III'],
    ['kms', 'КМС'],
    ['ms', 'МС'],
    ['msmk', 'МСМК'],
    ['zms', 'ЗМС'],
  ];

  public JUDGEMENT_CATEGORIES = [
    ['junior_judge', 'Юный судья'],
    ['3', 'III'],
    ['2', 'II'],
    ['1', 'I'],
    ['vk', 'ВК'],
    ['mk', 'МК'],
  ];

  private _previousFormValidValue;
  private _substitutedInput;
  private _imageNameToDisplay: string = '';

  private _wordsOnlyMatcher: RegExp = /[a-zа-я-\s]/giu;
  private _phoneNumberMatcher: RegExp = /^\+[1-9]\d{10}$/g;
  private trainersList = [
    ];

  private trainerNameIdMap;

  public form;

  @Input() player;
  @Input() tournamentId;
  @Input() edit: boolean = false;

  public city;
  public errors: any = {};
  private _noCityWasFound: boolean = false;
  private _queryIsBeingProcessed: boolean = false;
  private _citySearchBlurred: boolean = false;

  private _blurredDict = {
    last_name: false,
    name: false,
    surname: false,
    birthDate: false,
    phoneNumber: false,
  };

  private _fieldsValidationsResults = {
    last_name: false,
    name: false,
    surname: false,
    birthDate: false,
    phoneNumber: false,
  };

  private _fieldsSpecifiedValidators = {
    last_name: this.wordIsWrong.bind(this),
    name: this.wordIsWrong.bind(this),
    surname: this.wordIsWrong.bind(this),
    birthDate: this.dateIsWrong.bind(this),
    phoneNumber: this.phoneNumberIsWrong.bind(this),
  };


  private _imageSrc;

  constructor(private formBuilder: FormBuilder, private activeModal: NgbActiveModal, private playerService: PlayersService, private locationsService: LocationsService) {
    this.form = this.formBuilder.group({
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      surname: ['', Validators.required],
      title: [''],
      judgement_category: [''],
      city: ['', Validators.required],
      birthdate: [''],
      phone: [''],
      email: [''],
      image: [''],
      trainer: [''],
      cue: [''],
    });
  }

  ngOnInit(): void {

    this._substitutedInput = document.getElementById('image');

    if (this.player) {

      if (this.player.first_name) {
        this.form.controls.first_name.value = this.player.first_name;
      }
      if (this.player.last_name) {
        this.form.controls.last_name.value = this.player.last_name;
      }
      if (this.player.surname) {
        this.form.controls.surname.value = this.player.surname;
      }

      if (this.player.city) {
        this.city = this.player.city;
        this.form.controls.city.setValue(this.city.name);
      }

      if (this.player.title) {
        this.form.controls.title.value = this.player.title;
      }

      if (this.player.judgement_category) {
        this.form.controls.judgement_category.value = this.player.judgement_category;
      }

      if (this.player.birthdate) {
        this.form.controls.birthdate.value = moment(this.player.birthdate).format('DD.MM.YYYY');
      }

      if (this.player.phone) {
        this.form.controls.phone.value = this.player.phone;
      }

      if (this.player.email) {
        this.form.controls.email.value = this.player.email;
      }

      if (this.player.image) {
        let contentType = '';
        fetch(this.player.image)
          .then(response => {
            contentType = response.headers.get('content-type');
            return response.blob();
          })
          .then((imageBlob) => {
            const file = new File([imageBlob], `Фото игрока.${contentType.split('/')[1]}`, {
              type: contentType,
            });
            this.imageNameToDisplay = file.name;
            this.form.get('image').setValue(file);
          });
        this.imageSrc = this.player.image;
      }
    }
    if (this.player.trainer) {
      this.form.get('trainer').setValue(this.player.trainer);
    }

    if (this.player.cue) {
      this.form.get('cue').setValue(this.player.cue);
    }

  }


  clickOnInvisibleInput() {
    this._substitutedInput.click();
  }

  get noCityWasFound(): boolean {
    return  this._noCityWasFound;
  }

  set noCityWasFound(value) {
    this._noCityWasFound = value;
  }

  cityInputFormatter = (city) => city.name || city; //{ console.log('if', city); return city || '' };
  cityResultFormatter = (city) => `${city.name}, ${city.region.name}, ${city.region.country.name}`;

  searchCity: OperatorFunction<string, any> = (text$: Observable<string>) =>
    text$.pipe(
      // debounceTime(200),
      distinctUntilChanged(),
      // filter((term) => term.length >= 1),
      switchMap((term) => {
        if (term) {
          this.queryIsBeingProcessed = true;
          this.noCityWasFound = false;
          return this.locationsService.get(term);
        }
        return of([]);
      }),
      map((response: any) => {
        this.queryIsBeingProcessed = false;
        this.noCityWasFound = !response?.results?.length;
        return response.results
      })
      // map(term => states.filter(state => new RegExp(term, 'mi').test(state.name)).slice(0, 10))
    );

  private _actualQuery;
  searchTrainer: OperatorFunction<string, any> = (text$: Observable<string>) =>
    text$.pipe(
      distinctUntilChanged(),
      switchMap((query) => {
        if (query) {
          this._actualQuery = query;
          return this.playerService.search(query);
        }
        return of([]);
      }),
      map((response) => {
        //@ts-ignore
        return response.filter(trainer => trainer.last_name.toLowerCase().startsWith(this._actualQuery.toLowerCase()));
      }),
    );

  citySelect($event) {
    this.city = $event.item;
  }

  emptyCity(): boolean {
    return !this.form.controls.city.value;
  }


  trainerInputFormatter = (trainer) => {
    if (trainer?.last_name && trainer?.first_name) {
      return `${trainer?.last_name} ${trainer?.first_name}`;
    }
    return '';
  };
  trainerResultFormatter = (trainer) => `${trainer?.last_name} ${trainer?.first_name}`;

  trainerSelect($event) {
    this.form.controls.trainer.value = $event.item.id;
  }
  @ViewChild('instance', {static: true}) instance: NgbTypeahead;
  focus$ = new Subject<string>();
  click$ = new Subject<string>();

  search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => (term === '' ? this.getTrainerList()
        : this.getTrainerList().filter(v => v.toLowerCase().startsWith(term.toLowerCase()))
    )))
  }

  private getUserObj() {
    return {
      first_name: this.form.controls.first_name.value,
      last_name: this.form.controls.last_name.value,
      surname: this.form.controls.surname.value,
      title: this.form.controls.title.value,
      judgement_category: this.form.controls.judgement_category.value,
      city: this.city,
      birthdate: moment(this.form.controls.birthdate.value, 'DD.MM.YYYY').format('YYYY-MM-DD'),
      phone: this.form.controls.phone.value,
      email: this.form.controls.email.value,
      image: this.form.controls.image.value,
      trainer: this?.form?.controls?.trainer?.value?.id,
      cue: this.form.controls.cue.value,
    };
  }

  getTrainerList() {
    return this.trainersList;
  }

  setTrainerList(list) {
    this.trainersList = list;
  }

  create() {
    const player = this.getUserObj();
    this.clearErrors();
    this.playerService.createPlayer(player).subscribe(
      (createdPlayer: any) => {
        this.playerService.addPlayer(this.tournamentId, createdPlayer.id).subscribe(() => {
          this.activeModal.close();
        });
      },
      (response) => {
        this.setErrors(response.error);
      }
    );
  }

  update() {
    const player = this.getUserObj();
    this.clearErrors();

    this.playerService.update(this.player.id, player).subscribe(
      (updatedPlayer: any) => {
        this.activeModal.close();
      },
      (response) => {
        this.setErrors(response.error);
      }
    );
  }

  clearErrors() {
    this.errors = {};
  }

  setErrors(error) {
    for (let i in error) {
      if (error.hasOwnProperty(i)) {
        this.errors[i] = error[i];
      }
    }
  }
  onFileSelect(event): void {
    if (event.target.files.length > 0) {

      const reader = new FileReader();
      reader.onload = () => {
        this.imageSrc = reader.result;
      };

      const file = event.target.files[0];
      this.imageNameToDisplay = file.name;
      this.form.get('image').setValue(file);

      reader.readAsDataURL(file);
    }
  }

  getTrainerNameIdMap() {
    return this.trainerNameIdMap;
  }

  setTrainerNameIdMap(nameIdMap) {
    this.trainerNameIdMap = nameIdMap;
  }

  convertToTrainerNameIdMap(rawTrainersList) {
    const result = new Map();
    const listOfTrainers = [];
    rawTrainersList.forEach((rawTrainerData) => {
      result.set(rawTrainerData.full_name, rawTrainerData.id);
      listOfTrainers.push(rawTrainerData.full_name);
    });
    this.setTrainerNameIdMap(result);
    this.setTrainerList(listOfTrainers);
  }

  get queryIsBeingProcessed(): boolean {
    return  this._queryIsBeingProcessed;
  }

  set queryIsBeingProcessed(value) {
    this._queryIsBeingProcessed = value;
  }

  get citySearchBlurred(): boolean {
    return this._citySearchBlurred;
  }

  set citySearchBlurred(value) {
    this._citySearchBlurred = value;
  }

  citySearchBlurHandler() {
    this.citySearchBlurred = true;
  }

  citySearchFocusHandler() {
    this.citySearchBlurred = false;
  }


  blurOnEnter($event) {
    if ($event?.key === 'Enter') {
      $event.target.blur();
    }
  }

  cityError(): boolean {
    return (this.noCityWasFound && !this.emptyCity())
      || ((this.queryIsBeingProcessed || this.emptyCity()) && this.citySearchBlurred)
  }

  birthDateError(): boolean {
    for (let er in this.errors) {
      if (this.errors[er] == 'Birthdate is incorrect!') {
        return true;
      }
    }
    return false;
  }

  surnameError(): boolean {
    for (let er in this.errors) {
      if (er == 'surname' || this.errors[er] == 'You did not set surname field!') {
        return true;
      }
    }
    return false;
  }


  submitButtonDisabled(): boolean {
    let theRestFieldsValidationsResult = false;
    Object.keys(this.fieldsValidationsResults).forEach((key) => {
      theRestFieldsValidationsResult ||= this.fieldsValidationsResults[key];
    });
    return this.cityError() || this.queryIsBeingProcessed || this.emptyCity() || theRestFieldsValidationsResult;
  }

  buttonStyle(): string {
    return this.submitButtonDisabled()
      ? 'blockedButtonStyle'
      : 'btn btn-primary btn-sm';
  }

  get imageSrc() {
    return this._imageSrc;
  }

  set imageSrc(value) {
    this._imageSrc = value;
  }

  satisfiesRegexp(regexp: RegExp, expression: string) {
    const matchesArray = Array.from(expression.matchAll(regexp));
    return matchesArray.length === expression.length || expression.match(regexp); // found just one single string!
  }

  emptyEntry(entry) {
    return !entry;
  }

  dateIsWrong(dateString) {
    const actualStringToValidate = dateString.split('.').reverse().join('-');
    return new Date(actualStringToValidate).toDateString() === 'Invalid Date';
  }

  phoneNumberIsWrong(phoneNumber: string) {
    return !this.satisfiesRegexp(this._phoneNumberMatcher, phoneNumber);
  }

  wordIsWrong(word: string) {
    return !word || !this.satisfiesRegexp(this._wordsOnlyMatcher, word);
  }

  get blurredDict() {
    return this._blurredDict;
  }

  get fieldsValidationsResults() {
    return this._fieldsValidationsResults;
  }

  getSpecifiedValidator(key: string) {
    return this._fieldsSpecifiedValidators[key];
  }

  fieldBlurHandler($event, key) {
    this.fieldsValidationsResults[key] = this.getSpecifiedValidator(key)($event.target.value);
  }

  fieldOnFocusHandler($event, key) {
    this.fieldsValidationsResults[key] = false;
  }

  get imageNameToDisplay(): string {
    return this._imageNameToDisplay;
  }

  set imageNameToDisplay(value: string) {
    this._imageNameToDisplay = value;
  }

  trainerBlurHandler($event) {
    const actualTextValue = $event.target.value;

    if (!actualTextValue) {

      this.form.get('trainer').setValue('');
      this._previousFormValidValue = '';

    } else if (!this.form.get('trainer').value || !('id' in this.form.get('trainer').value)) {
      this.form.get('trainer').setValue(this._previousFormValidValue);
    }
  }

  trainerFocusHandler() {
    this._previousFormValidValue = this.form.get('trainer').value;
  }
}
